var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntroVideoRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M14.8837 0H14.8737C7.72709 0 1.93359 5.79344 1.93359 12.94V12.95C1.93359 20.0966 7.72709 25.89 14.8737 25.89H14.8837C22.0302 25.89 27.8236 20.0966 27.8236 12.95V12.94C27.8236 5.79344 22.0302 0 14.8837 0Z",
    fill: "#191919"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3667_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4632 8.98929C11.5332 8.96929 11.6032 8.9893 11.6632 9.0293L14.8733 12.3393L18.1233 9.0293C18.2833 8.9193 18.4932 9.0293 18.3532 9.1993L15.1032 12.5593L18.3833 15.9793C18.4733 16.1593 18.2733 16.2293 18.1333 16.1193L14.9232 12.8093L11.6732 16.1193C11.6132 16.1793 11.4732 16.1893 11.4132 16.1193L11.4332 15.9493L14.6932 12.5893C14.3632 12.2193 14.0132 11.8493 13.6732 11.4893C13.0132 10.8093 12.2332 10.1193 11.6132 9.4093C11.5432 9.3293 11.2632 9.04929 11.4732 8.98929H11.4632Z",
    fill: "#E4F5FD",
    stroke: "#E4F5FD",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3667_7",
    x: 0,
    y: 1.35645,
    width: 32.0312,
    height: 28.4414,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.121569 0 0 0 0 0.12549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3667_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3667_7",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroVideoRemove);
export default __webpack_public_path__ + "static/media/intro-video-remove.9d99392f4e7d7ebf19f485ec246624c0.svg";
export { ForwardRef as ReactComponent };